import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Company } from './../company.model';

@Component({
  selector: 'app-company-picture-color',
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './company-picture-color.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./company-picture-color.scss'],
})
export class CompanyPictureColor {
  company = input.required<Company>();
  tooltip = input<string | undefined>(undefined);
}
